// eslint-disable-next-line @backstage/no-undeclared-imports -- types-only, keeps the CLI out of the runtime image (PLAT-2947)
import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
